module.exports = __webpack_public_path__ + "img/xieyitop.3e9f72ad.png";